import Vue from 'vue'
import Router from 'vue-router'
import modules from './modules'
import mobile from './modules/mobile'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () => import('@/views/AppLogin.vue')
    },
    {
      path: '/pay/result/:orderNo',
      component: () => import('@/views/product/PayResult'),
      props: true,
      meta: { title: '支付完成' }
    },
    {
      path: '/',
      component: () => import('@/views/layout/Home.vue'),
      children: modules
    },
    ...mobile,
    {
      path: '/404',
      meta: {
        hidden: true
      },
      component: () => import('@/views/error/Page404.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
